/* istanbul ignore next */
import { createUseStyles } from '@glu/theming';

const styles = ({
  badge,
  button = {},
  formElements = {},
  palette: { common, error, text } = {},
  spacing = {},
  typography = {}
}) => ({
  gluOverride: {
    '& [data-qa="mobilegrid"]': {
      maxWidth: 'calc(100vw - 2rem)'
    },
    '& [class*="open"]': {
      zIndex: 2000
    },
    // TODO - CB-48476 - remove this after @glu/nav-react is upgraded (GLU-6168 is fixed in nav-react 3.4.3, so this is a duplicate fix which should be removed after the upgrade)
    '& [class*="openLogo"]': {
      display: 'flex',
      alignItems: 'center',
      '& svg, & img': {
        height: 'auto'
      }
    },
    fontSize: 16,
    '& [data-qa="date-select"] ': {
      // Add background to @glu/datepicker-react
      background: '#ffffff'
    },
    '& .visuallyHidden': {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    },
    fontFamily: typography.fontFamily,
    '& .glu-content, .glu-container, .container': {
      maxWidth: 'none'
    },
    '& .navbar': {
      borderRadius: 0
    },
    '& [class*="col-"]': {
      paddingLeft: spacing.unit * 2,
      paddingRight: spacing.unit * 2
    },
    '& .no-gutters': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '& h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6': {
      marginBottom: spacing.unit * 1.25
    },
    '& h4': {
      fontWeight: typography.fontWeightMedium
    },
    '& .badge': {
      ...badge
    },
    /** @description Grid Overrides, might want to put these somewhere else */
    '& .grid': {
      '& .navigate': {
        '& nav': {
          display: 'flex',
          alignItems: 'center',
          '& .flex-dropdown-wrapper': {
            display: 'flex !important', // important is reqd here, else will be overriden by component specific styles
            alignItems: 'center',
            paddingRight: spacing.unit / 2,
            '& label': {
              margin: 'auto',
              paddingRight: spacing.unit / 2
            }
          },
          '& span': {
            margin: 'auto'
          },
          '& .btn-tertiary': {
            marginLeft: spacing.unit / 2
          }
        }
      }
    },

    '& .shadow': {
      boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)'
    },

    '& .divider': {
      float: 'left',
      marginBottom: spacing.unit * 2,
      marginTop: spacing.unit * 2,
      width: '100%'
    },

    '& .no-label': {
      paddingTop: spacing.unit * 3.5
    },

    '& .radio-inline': {
      display: 'inline',
      lineHeight: 2,
      '& input': {
        boxShadow: 'none',
        bottom: 0
      }
    },

    '& .radio-inline-padded': {
      display: 'inline',
      paddingRight: '20px',
      '& input': {
        boxShadow: 'none',
        bottom: 0
      }
    },

    '& .optional label': {
      ...formElements.optionalLabel,
      display: 'inline-block',
      marginBottom: '5px',
      '& span': {
        fontWeight: 'normal',
        textTransform: 'capitalize',
        marginRight: '-10px'
      }
    },
    '& .optional label::after': {
      ...formElements.optionalAfter
    },
    '& .flex-dropdown-wrapper': {
      '& .flex-dropdown .selection': {
        borderRadius: 2
      }
    },
    '& .block-label .flex-dropdown-wrapper label': {
      display: 'block',
      lineHeight: '1.70em'
    },

    '& .block-label .flex-dropdown-wrapper .flex-dropdown': {
      width: '100%'
    },

    '& .form-group': {
      ...formElements.formGroup,
      '& .help-block, small': {
        color: text.midGray
      },
      '& .has-error': {
        '& small': {
          color: error.dark
        }
      }
    },
    '& .form-group.has-error': {
      '& .help-block': {
        color: error.dark
      }
    },

    '& .form-group label, .form-group .label': {
      ...formElements.label,
      marginBottom: '5px'
    },
    '& .text-wrap-normal': {
      whiteSpace: 'normal'
    },

    '& .form-group input': {
      ...formElements.input
    },

    /*
     * @TODO: Update colors from pallette
     */
    '& .has-error .form-control': {
      border: `1px solid ${error.dark}`
    },

    // Outline flex dropdown box
    '& .has-error .flex-dropdown .selection': {
      borderColor: error.dark
    },
    '& .has-error label': {
      color: error.dark
    },

    '& .form-control': {
      ...formElements.formControl
    },

    '& .form-control:focus': {
      boxShadow: 'none'
    },

    '& .btn': {
      fontFamily: typography.fontFamily,
      fontSize: typography.fontSize,
      ...button,
      '&.btn-primary': {
        ...button.primary
      },
      '&.btn-secondary': {
        ...button.secondary
      },
      '&.btn-link, &.btn-tertiary': {
        ...button.tertiary,
        fontFamily: typography.headline2.fontFamily,
        backgroundColor: 'transparent',
        textDecoration: 'none'
      },
      '&.btn-center': {
        display: 'flex',
        alignItems: 'center'
      }
    },

    '& .btn-toggle': {
      '&:first-child': {
        borderRadius: `${button.borderRadius}px 0 0 ${button.borderRadius}px`
      },
      '&:last-child': {
        borderRadius: `0 ${button.borderRadius}px ${button.borderRadius}px 0`
      }
    },

    '& .table-padded': {
      '& th,td': {
        paddingRight: spacing.unit * 2
      }
    },

    '& button': {
      borderWidth: 1
    },
    '& [class*="switchMain"]': {
      '&:after': {
        backgroundColor: common.white
      }
    },
    '& [class*="dropdownHeader"]': {
      flexWrap: 'wrap'
    },
    // glu datepicker-react global styles
    '& [class*="datepicker"]': {
      '& [data-qa="popup"]': {
        zIndex: 101
      }
    },
    '& input[type="checkbox"]:checked + div svg': {
      fill: text.dark
    },
    '& [data-qa^="dropdown"] > label': {
      width: '100%'
    },
    '& .sr-only': {
      position: 'absolute',
      width: 1,
      height: 1,
      padding: 0,
      overflow: 'hidden',
      clip: 'rect(0, 0, 0, 0)',
      whiteSpace: 'nowrap',
      clipPath: 'inset(50%)',
      border: 0
    },
    '& [data-qa="weekly"]': {
      '& button:focus': {
        border: '1px solid #5e9ed6'
      },
      '& button[class*="active"]:focus': {
        border: '1px solid #ff0000'
      }
    },
    '& [data-qa="receiverModal"]': {
      maxHeight: 'calc(100% - 80px)',
      maxWidth: '800px',
      overflowY: 'scroll'
    }
  }
});

export default createUseStyles(styles);
